var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('course-summary',{attrs:{"module_id":3},model:{value:(_vm.maximizeCard),callback:function ($$v) {_vm.maximizeCard=$$v},expression:"maximizeCard"}}),_c('div',{staticClass:"con-tab-ejemplo"},[_c('course-listing-component',{attrs:{"courseApplicationType":"General"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }